<template>
  <div class="cargo-pop-select-input">
    <el-input :value="displayName ? displayName : eventName" @click.native="dialogVisible=true" />
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="1160px"
      append-to-body
    >
      <div style="display: flex; margin: 10px">
        <span style="align-self:center; margin-right: 5px">{{ $t('CargoMsg.Cargo_Query') }}: </span>
        <el-input v-model="searchValue" :placeholder="$t('SeaExport.PleaseInputAKeyword')" style="width: 300px" @input="selectedBak = displayName" />
      </div>
      <div class="grid">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :grid-options="gridOptions"
          :row-data="filterData"
          :show-side-bar="false"
          style="height:100%;min-height: 400px;"
        />
      </div>
      <template slot="footer">
        <div style="display: flex;text-align: left;">
          <span class="blue">{{ $t('CargoMsg.Cargo_CurrentSelection') }}:</span>
          <div style="flex: 1;height: 28px;overflow-y: auto;text-align: left;word-break: break-word;margin-left: 5px">
            {{ displayName ? displayName : eventName }}
          </div>
        </div>
        <div>
          <el-button type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
          <el-button @click="onReset">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
          <el-button @click="handleClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
export default {
  name: 'TriggerDialog',
  components: { CargoAgGrid },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    columnDefs: {
      type: Array,
      default: () => []
    },
    rowData: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: () => ''
    },
    eventName: {
      type: String,
      default: () => ''
    },
    filterKeys: {
      type: Array,
      default: () => ['code', 'englishName', 'chineseName']
    }
  },
  data() {
    return {
      isAll: false,
      dialogVisible: false,
      searchValue: '',
      gridOptions: {
        rowSelection: 'single',
        onRowClicked: this.onRowClick
      },
      displayName: '',
      selectedData: null,
      selectedBak: ''
    }
  },
  computed: {
    filterData() {
      const { searchValue, rowData } = this
      if (!searchValue.trim()) {
        return rowData
      } else {
        const filterKeys = this.filterKeys
        return rowData.filter(row => {
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            if (row[key] && row[key].toLowerCase().indexOf(searchValue.trim().toLowerCase()) !== -1) return true
          }
        })
      }
    }
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      if (this.value) {
        const index = this.rowData.findIndex(item => item.uuid === this.value)
        if (index > -1) {
          const data = this.rowData[index]
          this.$nextTick(() => {
            const api = this.gridOptions.api
            api.setFocusedCell(index, api.columnController.getAllDisplayedColumns()[0])
            this.selectedData = data
            this.displayName = data.fieldName
          })
        } else {
          this.gridOptions.api.clearFocusedCell()
          this.selectedData = { uuid: this.value }
          this.displayName = ''
        }
      } else {
        this.selectedData = null
      }
      if (!newVal) {
        return
      }
    },
    filterData() {
      this.$nextTick(() => {
        this.displayName = this.selectedBak
      })
    }
  },
  methods: {
    onRowClick(event) {
      const data = event.data
      this.selectedData = data
      this.displayName = data.fieldName
    },
    onSave() {
      console.info('this.selectedData', this.selectedData)
      this.$emit('change', this.selectedData ? this.selectedData : '')
      this.handleClose()
    },
    onReset() {
      this.selectedBak = ' '
      this.selectedData = null
      this.displayName = ' '
      this.searchValue = ''
      this.gridOptions.api.clearFocusedCell()
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.cargo-pop-select-input{
  .operation {
    display: flex;
    justify-content: space-between;
  }
  .grid {
    display: flex;
    height: 460px;
  }
  .el-dialog__footer{
    display: flex;
    text-align: left;
    .blue {
      color: $--color-primary
    }
  }
}

</style>
